import { Highlight } from '@modules/feedback/types';
import { Box, Paper, Stack } from '@mui/material';
import { Feedback } from 'v2/core/entities/feedback';
import { FeedbackContentSurvey } from 'v2/core/entities/feedback/content';
import Answer from './SurveyTypeAnswer';
import Question from './SurveyTypeQuestion';
import SelectedOptions from './SurveyTypeSelectedOptions';
import { trackCopyFeedbackContentEvents } from '@modules/feedback/utils/trackCopyFeedbackContentEvents';

interface SurveyTypeProps {
  feedback: Feedback;
  highlights: {
    [key: string]: Highlight[];
  };
  showOriginalLanguage: boolean;
}

const SurveyType = ({
  feedback,
  highlights,
  showOriginalLanguage,
}: SurveyTypeProps) => {
  const content = showOriginalLanguage
    ? (feedback.content as FeedbackContentSurvey).responsesOriginal
    : (feedback.content as FeedbackContentSurvey).responsesEn;

  return (
    <Stack
      spacing={4}
      onCopy={() => {
        trackCopyFeedbackContentEvents({
          eventName: 'Copied Text From Feedback Content',
          feedbackID: feedback.id,
          feedbackType: feedback.content.type,
          contentType: 'raw',
        });
      }}
    >
      {content?.map((response, index) => {
        return (
          <Box
            key={index}
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Paper
              sx={{
                padding: 3,
                borderRadius: 2,
                width: '100%',
                backgroundColor: 'feedback.chatBubble.primary',
                boxShadow: 'none',
              }}
            >
              <Stack spacing={2}>
                <Question question={response.question} />
                <Answer
                  answer={response.answer}
                  highlights={highlights[index]}
                  msgIndex={index}
                  showOriginalLanguage={showOriginalLanguage}
                />
                <SelectedOptions
                  options={response.selectedOptions}
                  highlights={highlights[index]}
                  msgIndex={index}
                  showOriginalLanguage={showOriginalLanguage}
                />
              </Stack>
            </Paper>
          </Box>
        );
      })}
    </Stack>
  );
};

export default SurveyType;
